import React, { useEffect } from "react";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const HomePage = () => {
  useEffect(() => {
    const swiper = new Swiper(".financ-swiper", {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: false,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: false,
      breakpoints: {
        768: { slidesPerView: 2, spaceBetween: 30 },
        992: { slidesPerView: 3, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);
  useEffect(() => {
    const swiper = new Swiper(".h3-partner_slider", {
      slidesPerView: 2,
      spaceBetween: 15,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        992: { slidesPerView: 6, spaceBetween: 30 },
      },
    });

    return () => swiper.destroy(true, true); // cleanup
  }, []);

  return (
    <>
      {/*Hero Section */}
      <section
        className="hero-section bg-cover hero-3 z-[40]"
        style={{ backgroundImage: 'url("assets/images/hero-bg1.png")' }}
      >
        <div className="row g-4 align-items-center">
          <div className="col-xl-7 col-lg-6">
            <div className="hero-content">
              <h1 className="wow fadeIn animated" data-wow-delay=".2s">
                We are Helping Grow <span>Business</span> Success
              </h1>
              <div className="text-item wow fadeIn animated" data-wow-delay=".4s">
                <p>
                  Affordable OPD & Wellness Plans for You and Your Family – All in One Place, covering doctor consultations, diagnostics, preventive care, medicines, and more.
                </p>
              </div>
              <div
                className="hero-button wow fadeInUp animated"
                data-wow-delay=".6s"
              >
                <Link to="/plans" className="theme-btn btn-style-one">
                  Lets Explore Plans
                  <span className="icon">
                    <i className="flaticon-finance-arrow-right-svgrepo-com1-2" />
                  </span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-5 col-lg-6 wow fadeIn animated" data-wow-delay=".3s">
            <div className="hero-image ed_top_img">
              <img src="assets/images/hero.png" alt="img" />
              <div className="ellipse-shape">
                <img src="assets/images/home-3/hero/ellipse-shape.png" alt="img" />
              </div>
              <div className="text-circle">
                <img
                  src="assets/images/home-3/hero/text-circle.png"
                  alt="img"
                  className="animation__rotate"
                />
                <img src="assets/images/home-3/hero/star.png" alt="img" className="star" />
              </div>
            </div>
          </div>
        </div>
        <div className="paper-shape">
          <img src="assets/images/home-3/hero/paper-shape.png" alt="img" />
        </div>
      </section>

      {/*About Section */}
      <section className="about-section fix section-padding md:pb-[160px]">
        <div className="auto-container">
          <div className="row g-4">
            <div className="col-lg-6">
              <div className="image-column-3">
                <div className="inner-column">
                  <div
                    className="image1 overlay-anim wow fadeIn"
                    data-wow-delay=".3s"
                  >
                    <img src="assets/images/home-3/about/about-01.jpg" alt="Image" />
                  </div>
                  <div className="info float-bob-x">
                    <img src="assets/images/home-3/about/about-info.png" alt="Image" />
                  </div>
                  <div className="image2 wow fadeIn" data-wow-delay=".5s">
                    <img src="assets/images/home-3/about/about-02.jpg" alt="Image" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-content-3">
                <div className="sec-title mb-0">
                  <h6 className="sub-title wow fadeIn">
                    <span className="triangle triangle1" />
                    <span className="triangle triangle2" />
                    Who We Are
                  </h6>
                  <h2 className="wow fadeIn" data-wow-delay=".2s">
                    The Journey Behind Our Business Success
                  </h2>
                </div>
                <p className="about-text wow fadeIn" data-wow-delay=".4s">
                  At Zealthix Technologies, we make healthcare accessible, transparent, and stress-free. Our OPD coverage and wellness plans serve individuals, families, and corporates — from routine checkups to preventive care, we’ve got you covered.
                </p>
                <div className="about-block wow fadeIn" data-wow-delay=".6s">
                  <div className="inner-box">
                    <div className="icon">
                      <i className="flaticon-finance-creativity-1-1" />
                    </div>
                    <div className="content">
                      <h4 className="title">OPD Plans</h4>
                      <p className="text">
                       Doctor Consultations (General & Specialist), Diagnostic Tests & Lab Screenings, Prescribed Medicines Coverage, Easy Digital Claims & Cashless Options and more.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="about-block wow fadeIn" data-wow-delay=".8s">
                  <div className="inner-box">
                    <div className="icon">
                      <i className="flaticon-finance-edit-tools-1" />
                    </div>
                    <div className="content">
                      <h4 className="title">Wellness Plans</h4>
                      <p className="text">
                        Annual Health Checkups, Nutrition & Lifestyle Guidance, Mental Wellness Support, Preventive Health Screenings, etc.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="info mt-50 wow fadeIn" data-wow-delay=".2s">
                  <Link
                    to="/contact"
                    className="theme-btn btn-style-one wow fadeIn"
                    data-wow-delay=".5s"
                  >
                    Lets Talk With Us
                    <span className="icon">
                      <i className="flaticon-finance-arrow-right-svgrepo-com1-2" />
                    </span>
                  </Link>
                  <div className="user">
                    <div className="image">
                      <img src="assets/images/founder-photo.jpg" alt="Image" />
                    </div>
                    <div>
                      <img src="assets/images/signature.png" alt="Image" />
                      <p className="sub-title">Founder</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Why Choose Us Section Start */}
      <section
        className="why-choose-section-2 section-padding fix bg-cover max-md:pt-[40px] max-md:pb-[100px]"
        style={{ backgroundImage: 'url("assets/images/home-3/service-bg-2.jpg")' }}
      >
        <div className="circle-shape">
          <img src="assets/images/home-2/choose-us/circle-shape.png" alt="img" />
        </div>
        <div className="auto-container">
          <div className="why-choose-us-wrapper-2 p-0">
            <div className="row g-4 justify-content-between">
              <div className="col-xl-5">
                <div
                  className="service-imagestyle-3 fix wow fadeIn"
                  data-wow-delay=".3s"
                >
                  <img src="assets/images/home-3/service-image.jpg" alt="img" />
                </div>
              </div>
              <div className="col-xl-7">
                <div className="choose-us-content-2 relative">
                  <div className="sec-title mb-0">
                    <h6 className="sub-title text-white">
                      <span className="triangle triangle1" />
                      <span className="triangle triangle2" />
                      Services
                    </h6>
                    <h2 className="text-white wow fadeIn" data-wow-delay=".2s">
                      Building a Healthier Future — Starting Now
                    </h2>
                  </div>
                  <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-6 wow fadeIn">
                      <div className="choose-us-box-style-2">
                        <div className="icon">
                          <i className="flaticon-finance-business-expense-svgrepo-com-1" />
                        </div>
                        <div className="content">
                          <h3>
                              Unlimited Tele-consultations
                          </h3>
                          <p>
                            Access doctors 24/7 with unlimited virtual consultations — care without leaving home.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xl-6 col-lg-6 col-md-6 wow fadeIn"
                      data-wow-delay=".2s"
                    >
                      <div className="choose-us-box-style-2">
                        <div className="icon">
                          <i className=" lnr-icon-layers" />
                        </div>
                        <div className="content">
                          <h3>
                             Diagnostic Wallet
                          </h3>
                          <p>
                            Enjoy a prepaid diagnostic wallet for lab tests at partner centers — cashless, simple, and discounted.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xl-6 col-lg-6 col-md-6 wow fadeIn"
                      data-wow-delay=".4s"
                    >
                      <div className="choose-us-box-style-2">
                        <div className="icon">
                          <i className="flaticon-business-023-lifesaver" />
                        </div>
                        <div className="content">
                          <h3>Pharmacy Benefits
                          </h3>
                          <p>
                            Save on medicines through partner pharmacies — affordable care for your long-term needs.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-xl-6 col-lg-6 col-md-6 wow fadeIn"
                      data-wow-delay=".6s"
                    >
                      <div className="choose-us-box-style-2">
                        <div className="icon">
                          <i className="lnr-icon-folder-open" />
                        </div>
                        <div className="content">
                          <h3>Family Coverage
                          </h3>
                          <p>
                            Cover up to 4 family members under every wellness plan — protect your loved ones with ease.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-white absolute bottom-[-80px] right-0 text-[18px] max-md:bottom-[-40px]">& many more...</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/*Feature Section */}
      <section className="feature-section-3 fix pb-[100px]">
        <div className="row g-4">
          <div className="col-lg-5">
            <div className="feature-box-3">
              <div className="arrow-shape">
                <img src="assets/images/home-3/arrow-shape.png" alt="img" />
              </div>
              <div className="client-image client-image-width wow fadeIn" data-wow-delay=".2s">
                <img src="assets/images/home-1/client-1.png" alt="img" />
                <img
                  src="assets/images/home-1/client-2.png"
                  alt="img"
                  className="icon-2"
                />
                <img
                  src="assets/images/home-1/client-3.png"
                  alt="img"
                  className="icon-3"
                />
                <img
                  src="assets/images/home-1/client-4.png"
                  alt="img"
                  className="icon-4"
                />
              </div>
              <span className="wow fadeIn" data-wow-delay=".4s">
                <b>40+</b> Active Partners
              </span>
              <Link
                    to="/contact"
                    className="theme-btn btn-style-one wow fadeIn"
                    data-wow-delay=".5s"
                  >
                    Lets Talk With Us
                    <span className="icon">
                      <i className="flaticon-finance-arrow-right-svgrepo-com1-2" />
                    </span>
                  </Link>
                  
            </div>
          </div>
          <div className="col-lg-7">
            <div className="row g-4">
              <div
                className="col-xl-6 col-lg-12 col-sm-6 wow fadeIn"
                data-wow-delay=".3s"
              >
                <div className="feature-service-card-items">
                  <div className="icon">
                    <i className="flaticon-business-028-briefcase" />
                  </div>
                  <div className="content">
                    <h3>
                      Transparent Pricing
                    </h3>
                    <p>
                      To bring clarity, trust, and fairness in healthcare costs through transparent pricing with OPD partners — ensuring affordable access and peace of mind for every family.
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-xl-6 col-lg-12 col-sm-6 wow fadeIn"
                data-wow-delay=".5s"
              >
                <div className="feature-service-card-items">
                  <div className="icon">
                    <i className="flaticon-finance-business-expense-svgrepo-com-1" />
                  </div>
                  <div className="content">
                    <h3>Pan-India Network
                    </h3>
                    <p>
                      To build a strong Pan-India network of trusted OPD and wellness partners — delivering accessible, reliable, and affordable healthcare for every individual and family.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HomePage;
